import { render } from "./MembersBasicInfoView.vue?vue&type=template&id=61e61e64"
import script from "./MembersBasicInfoView.vue?vue&type=script&lang=js"
export * from "./MembersBasicInfoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__